import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-080ec601"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Clínica ")
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-8" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "row mt-20" }
const _hoisted_9 = { class: "form-label" }
const _hoisted_10 = { class: "col-9" }
const _hoisted_11 = { class: "col-3" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Asociar ")
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = { class: "form-label" }
const _hoisted_15 = {
  key: 0,
  class: "product-list"
}
const _hoisted_16 = { class: "fw-bold" }
const _hoisted_17 = { class: "ms-10" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_19 = { class: "fw-normal" }
const _hoisted_20 = {
  key: 1,
  class: "col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_v_form_group_read_only_text = _resolveComponent("v-form-group-read-only-text")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_modal_body = _resolveComponent("modal-body")!
  const _component_modal_footer = _resolveComponent("modal-footer")!
  const _component_v_modal = _resolveComponent("v-modal")!

  return (_openBlock(), _createBlock(_component_v_modal, null, {
    default: _withCtx(() => [
      _createVNode(_component_modal_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_title, { as: "h4" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_modal_body, null, {
        default: _withCtx(() => [
          (!this.clinic)
            ? (_openBlock(), _createBlock(_component_v_loader, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_v_form_group_read_only_text, {
                        label: _ctx.$t('Nombre'),
                        text: _ctx.clinic.name
                      }, null, 8, ["label", "text"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_v_form_group_read_only_text, {
                        label: _ctx.$t('Teléfono'),
                        text: _ctx.clinic.phoneNumber
                      }, null, 8, ["label", "text"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_v_form_group_read_only_text, {
                        label: _ctx.$t('Dirección'),
                        text: _ctx.clinic.address
                      }, null, 8, ["label", "text"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('Asociar profesional a la clínica')), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_v_form_group_select, { class: "mb-40" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          options: _ctx.availableProfessionalOptions,
                          reduce: returnValue => returnValue.key,
                          placeholder: "",
                          "select-on-key-codes": [188, 13],
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedProfesional = $event)),
                          modelValue: _ctx.selectedProfesional,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedProfesional) = $event))
                        }, {
                          "no-options": _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                          ]),
                          _: 1
                        }, 8, ["options", "reduce", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_v_button, {
                      variant: "secondary",
                      "aria-label": _ctx.$t('Asociar'),
                      onClick: _cache[2] || (_cache[2] = () => { _ctx.associateProfessionalWithClinic(_ctx.selectedProfesional, _ctx.clinic.id); }),
                      disabled: !_ctx.selectedProfesional
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["aria-label", "disabled"])
                  ])
                ]),
                (_ctx.clinic.professionals)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('Profesionales asociados a la clínica')), 1),
                      (_ctx.clinic.professionals.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clinic.professionals, (professional) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "product-container-item d-flex justify-content-between align-items-center text-primary py-8 px-16",
                                key: professional.id
                              }, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(professional.nif) + " - ", 1),
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(professional.name) + " " + _toDisplayString(professional.surname), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_v_button, {
                                    variant: "icon",
                                    class: "btn-sm justify-content-center d-flex flex-column p-0",
                                    onClick: () => { _ctx.disassociateProfessionalFromClinic(professional.id, _ctx.clinic.id) }
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_18,
                                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('Desasociar')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('No hay profesionales asociados a esta clínica')), 1))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        _: 1
      }),
      _createVNode(_component_modal_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_button, {
            variant: "link-secondary",
            class: "me-24",
            "aria-label": _ctx.$t('Cancelar'),
            "data-bs-dismiss": "modal"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}